import { isPropertyDefined, isPropertyDefinedCb } from "@recursyve/nice-ts-utils";
import { Equipments } from "../../api/acl/equipments/models/equipments.model";

export function sortEquipmentsByNumericIdentifier(equipments: Equipments[]): Equipments[] {
    const equipmentsWithIdentifier = equipments.filter((equipment) => isPropertyDefined(equipment, "identifier"));
    const equipmentsWithoutIdentifier = equipments.filter((equipment) => !isPropertyDefined(equipment, "identifier"));

    return [
        ...equipmentsWithIdentifier
            .sort((equipmentA, equipmentB) =>
                equipmentA.identifier.localeCompare(equipmentB.identifier, undefined, { numeric: true })
            ),
        ...equipmentsWithoutIdentifier
    ];
}

export function sortEquipmentsByClientIdNotNull(equipments: Equipments[]): Equipments[] {
    const equipmentsWithClientId = equipments.filter(isPropertyDefinedCb("clientId"));
    const equipmentsWithoutClientId = equipments.filter((x) => !isPropertyDefined(x, "clientId"));

    return [
        ...equipmentsWithClientId,
        ...equipmentsWithoutClientId
    ];
}
